import { useTheme } from "modules/platform/hooks/useTheme";
export default function Loading({ size = 48 }: { size?: number }) {
  const theme = useTheme();
  return (
    <div className="w-full h-full flex items-center justify-center">
      <img src={theme.loading} alt="loading icon" style={{ width: size }} />
    </div>
  );
}
